'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _last2 = require('lodash/last');

var _last3 = _interopRequireDefault(_last2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _reactRedux = require('react-redux');

var _myPlaylists = require('redux/modules/my-playlists');

var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _reactRouterRedux = require('react-router-redux');

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _log = require('utils/log');

var _log2 = _interopRequireDefault(_log);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var AddPlaylistButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    addMyPlaylistLoading: state.myPlaylists.addMyPlaylistLoading
  };
}, (0, _extends3.default)({}, myPlaylistsActions, { pushState: _reactRouterRedux.push })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(AddPlaylistButton, _Component);

  function AddPlaylistButton() {
    (0, _classCallCheck3.default)(this, AddPlaylistButton);
    return (0, _possibleConstructorReturn3.default)(this, (AddPlaylistButton.__proto__ || (0, _getPrototypeOf2.default)(AddPlaylistButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddPlaylistButton, [{
    key: 'add',
    value: function add() {
      var _props = this.props,
          pushState = _props.pushState,
          addMyPlaylist = _props.addMyPlaylist;

      addMyPlaylist().promise.then(function () {
        var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { data: [] };

        var lastPlaylists = (0, _last3.default)(resp.data) || {};
        var guid = lastPlaylists.guid;
        if (guid) {
          pushState('/my-playlists/' + guid);
        }
      }).catch(_log2.default.w);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          title = _props2.title,
          className = _props2.className,
          addMyPlaylistLoading = _props2.addMyPlaylistLoading;

      var buttonTitle = title || t('Create new');

      return _react2.default.createElement(
        _Button2.default,
        {
          className: (0, _bind2.default)('btn btn-primary', className),
          onClick: this.add,
          loading: addMyPlaylistLoading
        },
        buttonTitle
      );
    }
  }]);
  return AddPlaylistButton;
}(_react.Component), _class3.propTypes = {
  addMyPlaylist: _propTypes2.default.func,
  addMyPlaylistLoading: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  pushState: _propTypes2.default.func,
  t: _propTypes2.default.func,
  title: _propTypes2.default.string
}, _class3.defaultProps = {
  prop: {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'add', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'add'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = AddPlaylistButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylists/components/AddPlaylistButton.js
// module id = 2171
// module chunks = 1